<strong class="title">Meta Information</strong>
@if (gear()?.gear; as info) {
  <div class="info">
    <div>
      <strong>Name</strong>
      <span>{{ info.name }}</span>
    </div>
    <div>
      <strong>Author</strong>
      <span>{{ info.author }}</span>
    </div>
    <div>
      <strong>Maintainer</strong>
      <span>{{ info.maintainer }}</span>
    </div>
    <div>
      <strong>Version</strong>
      <span>{{ info.version }}</span>
    </div>
    <div>
      <strong>Source</strong>
      <a [href]="info.source | trusturl" target="_blank">{{ info.source }}</a>
    </div>
    <div>
      <strong>URL</strong>
      <a [href]="info.url | trusturl" target="_blank">{{ info.url }}</a>
    </div>
    <div>
      <strong>License</strong>
      <span>{{ info.license }}</span>
    </div>
  </div>
}
